var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getWebMcpTools, registerWebMcpTools, executeWebMcpTool } from '../../common/base/constant';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
var webMcpTools = [
    {
        name: 'setDataSource',
        annotations: {
            readOnlyHint: false
        },
        description: 'Load a new dataset into the pivot table. Supports JSON data (array of objects), CSV data (array of arrays), or URL to data source.',
        inputSchema: {
            type: 'object',
            properties: {
                dataSource: {
                    type: 'array',
                    description: 'The new data source to load into the pivot table. Can be an array of objects (JSON) or array of arrays (CSV).'
                },
                url: {
                    type: 'string',
                    description: 'URL to the data source. Can be JSON or CSV data.'
                },
                type: {
                    type: 'string',
                    description: 'Explicitly specify the data type (JSON or CSV). If not provided, type will be inferred from file extension.'
                }
            },
            required: ['dataSource']
        },
        outputSchema: {
            type: 'object',
            properties: {
                success: { type: 'boolean' },
                data: { type: 'object' },
                message: { type: 'string' }
            },
            required: ['success', 'data', 'message']
        }
    },
    {
        name: 'addFieldToAxis',
        annotations: {
            readOnlyHint: false
        },
        description: 'Add a field to a specific axis (rows, columns, values, or filters)',
        inputSchema: {
            type: 'object',
            properties: {
                fieldName: { type: 'string', description: 'The name of the field to add' },
                axis: { type: 'string', description: 'The axis to add the field to (rows, columns, values, or filters)' }
            },
            required: ['fieldName', 'axis']
        },
        outputSchema: {
            type: 'object',
            properties: {
                success: { type: 'boolean' },
                data: { type: 'object' },
                message: { type: 'string' }
            },
            required: ['success', 'data', 'message']
        }
    },
    {
        name: 'removeFieldFromAxis',
        annotations: {
            readOnlyHint: false
        },
        description: 'Remove a field from a specific axis',
        inputSchema: {
            type: 'object',
            properties: {
                fieldName: { type: 'string', description: 'The name of the field to remove' },
                axis: { type: 'string', description: 'The axis to remove the field from (rows, columns, values, or filters)' }
            },
            required: ['fieldName', 'axis']
        },
        outputSchema: {
            type: 'object',
            properties: {
                success: { type: 'boolean' },
                data: { type: 'object' },
                message: { type: 'string' }
            },
            required: ['success', 'data', 'message']
        }
    },
    {
        name: 'moveFieldBetweenAxes',
        annotations: {
            readOnlyHint: false
        },
        description: 'Move a field from one axis to another',
        inputSchema: {
            type: 'object',
            properties: {
                fieldName: { type: 'string', description: 'The name of the field to move' },
                fromAxis: { type: 'string', description: 'The axis to move the field from' },
                toAxis: { type: 'string', description: 'The axis to move the field to' }
            },
            required: ['fieldName', 'fromAxis', 'toAxis']
        },
        outputSchema: {
            type: 'object',
            properties: {
                success: { type: 'boolean' },
                data: { type: 'object' },
                message: { type: 'string' }
            },
            required: ['success', 'data', 'message']
        }
    },
    {
        name: 'applyFiltering',
        annotations: {
            readOnlyHint: false
        },
        description: 'Apply various types of filters to the data including member filters, label filters, and value filters',
        inputSchema: {
            type: 'object',
            properties: {
                filters: {
                    type: 'array',
                    description: 'Array of filter objects',
                    items: {
                        type: 'object',
                        properties: {
                            name: { type: 'string', description: 'The field name to apply filtering to' },
                            type: { type: 'string', description: 'The filter type (Include, Exclude, Label, Date, Number, Value)' },
                            items: {
                                type: 'array',
                                description: 'Array of field members to include/exclude',
                                items: { type: 'string' }
                            },
                            condition: { type: 'string', description: 'The condition operator for conditional filtering (Equals, NotEquals, GreaterThan, etc.)' },
                            value1: { type: ['string', 'number'], description: 'The first value for comparison' },
                            value2: { type: ['string', 'number'], description: 'The second value for comparison (used with Between and NotBetween conditions)' }
                        },
                        required: ['name']
                    }
                }
            },
            required: ['filters']
        },
        outputSchema: {
            type: 'object',
            properties: {
                success: { type: 'boolean' },
                data: { type: 'object' },
                message: { type: 'string' }
            },
            required: ['success', 'data', 'message']
        }
    },
    {
        name: 'applySorting',
        annotations: {
            readOnlyHint: false
        },
        description: 'Sort data by specific fields in ascending or descending order',
        inputSchema: {
            type: 'object',
            properties: {
                sortSettings: {
                    type: 'array',
                    description: 'Array of sort objects',
                    items: {
                        type: 'object',
                        properties: {
                            name: { type: 'string', description: 'The field name to apply sorting to' },
                            order: { type: 'string', description: 'The sort order (Ascending, Descending, None)', enum: ['Ascending', 'Descending', 'None'] }
                        },
                        required: ['name', 'order']
                    }
                }
            },
            required: ['sortSettings']
        },
        outputSchema: {
            type: 'object',
            properties: {
                success: { type: 'boolean' },
                data: { type: 'object' },
                message: { type: 'string' }
            },
            required: ['success', 'data', 'message']
        }
    },
    {
        name: 'applyValueSorting',
        annotations: {
            readOnlyHint: false
        },
        description: 'Sort data based on value measures rather than field names. Requires enableValueSorting property to be set to true.',
        inputSchema: {
            type: 'object',
            properties: {
                valueSortSettings: {
                    type: 'object',
                    description: 'Value sort settings object',
                    properties: {
                        headerText: { type: 'string', description: 'The header text of the value to sort by' },
                        headerDelimiter: { type: 'string', description: 'Delimiter used in the header text' },
                        sortOrder: { type: 'string', description: 'The sort order (Ascending, Descending)', enum: ['Ascending', 'Descending'] },
                        columnHeaderText: { type: 'string', description: 'The column header text for multiple axis sorting' },
                        columnSortOrder: { type: 'string', description: 'The column sort order for multiple axis sorting', enum: ['Ascending', 'Descending'] },
                        rowHeaderText: { type: 'string', description: 'The row header text for multiple axis sorting' },
                        rowSortOrder: { type: 'string', description: 'The row sort order for multiple axis sorting', enum: ['Ascending', 'Descending'] }
                    },
                    required: ['headerText', 'sortOrder']
                }
            },
            required: ['valueSortSettings']
        },
        outputSchema: {
            type: 'object',
            properties: {
                success: { type: 'boolean' },
                data: { type: 'object' },
                message: { type: 'string' }
            },
            required: ['success', 'data', 'message']
        }
    },
    {
        name: 'clearAllFilters',
        annotations: {
            readOnlyHint: false
        },
        description: 'Remove all applied filters to see the complete dataset',
        inputSchema: {
            type: 'object',
            properties: {}
        },
        outputSchema: {
            type: 'object',
            properties: {
                success: { type: 'boolean' },
                data: { type: 'object' },
                message: { type: 'string' }
            },
            required: ['success', 'data', 'message']
        }
    },
    {
        name: 'applyConditionalFormatting',
        annotations: {
            readOnlyHint: false
        },
        description: 'Apply visual formatting rules to highlight cells based on their values. Requires allowConditionalFormatting property to be set to true and ConditionalFormatting module to be injected.',
        inputSchema: {
            type: 'object',
            properties: {
                formatRules: {
                    type: 'array',
                    description: 'Array of conditional formatting rules',
                    items: {
                        type: 'object',
                        properties: {
                            measure: { type: 'string', description: 'The value field name to apply formatting to (optional - if not provided, applies to all fields)' },
                            conditions: {
                                type: 'string',
                                description: 'The condition operator (e.g., LessThan, GreaterThan, Equals, Between, etc.)'
                            },
                            value1: { type: 'number', description: 'The first value for comparison' },
                            value2: { type: 'number', description: 'The second value for comparison (used with Between and NotBetween conditions)' },
                            style: {
                                type: 'object',
                                description: 'The styling to apply',
                                properties: {
                                    backgroundColor: { type: 'string', description: 'Background color' },
                                    color: { type: 'string', description: 'Font color' },
                                    fontFamily: { type: 'string', description: 'Font family' },
                                    fontSize: { type: 'string', description: 'Font size' }
                                }
                            },
                            applyGrandTotals: { type: 'boolean', description: 'Whether to apply formatting to grand totals' }
                        },
                        required: ['conditions', 'value1', 'style']
                    }
                }
            },
            required: ['formatRules']
        },
        outputSchema: {
            type: 'object',
            properties: {
                success: { type: 'boolean' },
                data: { type: 'object' },
                message: { type: 'string' }
            },
            required: ['success', 'data', 'message']
        }
    },
    {
        name: 'manageCalculatedField',
        annotations: {
            readOnlyHint: false
        },
        description: 'Create, update, or delete a calculated field using formulas based on existing fields',
        inputSchema: {
            type: 'object',
            properties: {
                action: {
                    type: 'string',
                    enum: ['create', 'update', 'delete'],
                    description: 'The action to perform on the calculated field'
                },
                fieldName: { type: 'string', description: 'The name of the calculated field (auto-generated if not provided by user)' },
                formula: { type: 'string', description: 'The formula for the calculated field (required for create/update)' }
            },
            required: ['action', 'fieldName']
        },
        outputSchema: {
            type: 'object',
            properties: {
                success: { type: 'boolean' },
                data: { type: 'object' },
                message: { type: 'string' }
            },
            required: ['success', 'data', 'message']
        }
    },
    {
        name: 'clearSorting',
        annotations: {
            readOnlyHint: false
        },
        description: 'Clear all applied sorting to restore default ordering',
        inputSchema: {
            type: 'object',
            properties: {}
        },
        outputSchema: {
            type: 'object',
            properties: {
                success: { type: 'boolean' },
                data: { type: 'object' },
                message: { type: 'string' }
            },
            required: ['success', 'data', 'message']
        }
    },
    {
        name: 'clearConditionalFormatting',
        annotations: {
            readOnlyHint: false
        },
        description: 'Remove all applied conditional formatting rules',
        inputSchema: {
            type: 'object',
            properties: {}
        },
        outputSchema: {
            type: 'object',
            properties: {
                success: { type: 'boolean' },
                data: { type: 'object' },
                message: { type: 'string' }
            },
            required: ['success', 'data', 'message']
        }
    },
    {
        name: 'clearNumberFormatting',
        annotations: {
            readOnlyHint: false
        },
        description: 'Remove all applied number formatting to restore default formatting',
        inputSchema: {
            type: 'object',
            properties: {}
        },
        outputSchema: {
            type: 'object',
            properties: {
                success: { type: 'boolean' },
                data: { type: 'object' },
                message: { type: 'string' }
            },
            required: ['success', 'data', 'message']
        }
    },
    {
        name: 'exportToExcel',
        annotations: {
            readOnlyHint: false
        },
        description: 'Export the pivot table data to an Excel file for further analysis. Requires allowExcelExport property to be set to true and ExcelExport module to be injected.',
        inputSchema: {
            type: 'object',
            properties: {
                exportProperties: {
                    type: 'object',
                    description: 'Additional properties for Excel export, including fileName',
                    properties: {
                        fileName: { type: 'string', description: 'The name of the exported file' }
                    }
                }
            }
        },
        outputSchema: {
            type: 'object',
            properties: {
                success: { type: 'boolean' },
                data: {
                    type: 'object',
                    properties: {
                        filePath: { type: 'string' }
                    }
                },
                message: { type: 'string' }
            },
            required: ['success', 'data', 'message']
        }
    },
    {
        name: 'exportToPDF',
        annotations: {
            readOnlyHint: false
        },
        description: 'Export the pivot table to a PDF document for sharing or printing. Requires allowPdfExport property to be set to true and PDFExport module to be injected.',
        inputSchema: {
            type: 'object',
            properties: {
                exportProperties: {
                    type: 'object',
                    description: 'Additional properties for PDF export, including fileName',
                    properties: {
                        fileName: { type: 'string', description: 'The name of the exported file' }
                    }
                }
            }
        },
        outputSchema: {
            type: 'object',
            properties: {
                success: { type: 'boolean' },
                data: {
                    type: 'object',
                    properties: {
                        filePath: { type: 'string' }
                    }
                },
                message: { type: 'string' }
            },
            required: ['success', 'data', 'message']
        }
    },
    {
        name: 'exportToCSV',
        annotations: {
            readOnlyHint: false
        },
        description: 'Export the pivot table data to a CSV file for import into other systems. Requires allowExcelExport property to be set to true and ExcelExport module to be injected.',
        inputSchema: {
            type: 'object',
            properties: {
                exportProperties: {
                    type: 'object',
                    description: 'Additional properties for CSV export, including fileName',
                    properties: {
                        fileName: { type: 'string', description: 'The name of the exported file' }
                    }
                }
            }
        },
        outputSchema: {
            type: 'object',
            properties: {
                success: { type: 'boolean' },
                data: {
                    type: 'object',
                    properties: {
                        filePath: { type: 'string' }
                    }
                },
                message: { type: 'string' }
            },
            required: ['success', 'data', 'message']
        }
    },
    {
        name: 'drillDownField',
        annotations: {
            readOnlyHint: false
        },
        description: 'Expand a specific hierarchical field to see more detailed data.',
        inputSchema: {
            type: 'object',
            properties: {
                fieldName: { type: 'string', description: 'The name of the field to drill down' },
                axis: { type: 'string', description: 'The axis containing the field (rows or columns)' },
                drillMembers: {
                    type: 'array',
                    description: 'Optional list of specific members to expand for this field using drilledMembers.',
                    items: { type: 'string' }
                },
                delimiter: {
                    type: 'string',
                    description: 'Optional delimiter for hierarchical member items used in drillMembers. Default: **'
                }
            },
            required: ['fieldName', 'axis']
        },
        outputSchema: {
            type: 'object',
            properties: {
                success: { type: 'boolean' },
                data: { type: 'object' },
                message: { type: 'string' }
            },
            required: ['success', 'data', 'message']
        }
    },
    {
        name: 'drillUpField',
        annotations: {
            readOnlyHint: false
        },
        description: 'Collapse a specific hierarchical field to see less detailed data.',
        inputSchema: {
            type: 'object',
            properties: {
                fieldName: { type: 'string', description: 'The name of the field to drill up' },
                axis: { type: 'string', description: 'The axis containing the field (rows or columns)' },
                drillMembers: {
                    type: 'array',
                    description: 'Optional list of specific members to collapse for this field using drilledMembers.',
                    items: { type: 'string' }
                },
                delimiter: {
                    type: 'string',
                    description: 'Optional delimiter for hierarchical member items used in drillMembers. Default: **'
                }
            },
            required: ['fieldName', 'axis']
        },
        outputSchema: {
            type: 'object',
            properties: {
                success: { type: 'boolean' },
                data: { type: 'object' },
                message: { type: 'string' }
            },
            required: ['success', 'data', 'message']
        }
    },
    {
        name: 'expandAllHeaders',
        annotations: {
            readOnlyHint: false
        },
        description: 'Expand all hierarchical fields at once to see detailed data across all dimensions.',
        inputSchema: {
            type: 'object',
            properties: {}
        },
        outputSchema: {
            type: 'object',
            properties: {
                success: { type: 'boolean' },
                data: { type: 'object' },
                message: { type: 'string' }
            },
            required: ['success', 'data', 'message']
        }
    },
    {
        name: 'collapseAllHeaders',
        annotations: {
            readOnlyHint: false
        },
        description: 'Collapse all hierarchical fields at once to see summarized data only.',
        inputSchema: {
            type: 'object',
            properties: {}
        },
        outputSchema: {
            type: 'object',
            properties: {
                success: { type: 'boolean' },
                data: { type: 'object' },
                message: { type: 'string' }
            },
            required: ['success', 'data', 'message']
        }
    },
    {
        name: 'setChartType',
        annotations: {
            readOnlyHint: false
        },
        description: 'Change the visualization type of the pivot chart',
        inputSchema: {
            type: 'object',
            properties: {
                chartType: { type: 'string', description: 'The type of chart to display (e.g., column, line, pie)' }
            },
            required: ['chartType']
        },
        outputSchema: {
            type: 'object',
            properties: {
                success: { type: 'boolean' },
                data: { type: 'object' },
                message: { type: 'string' }
            },
            required: ['success', 'data', 'message']
        }
    },
    {
        name: 'toggleViewMode',
        annotations: {
            readOnlyHint: false
        },
        description: 'Switch between table view and chart view to better analyze the data',
        inputSchema: {
            type: 'object',
            properties: {
                viewMode: { type: 'string', description: 'The view mode to switch to (table or chart or Both)' }
            },
            required: ['viewMode']
        },
        outputSchema: {
            type: 'object',
            properties: {
                success: { type: 'boolean' },
                data: { type: 'object' },
                message: { type: 'string' }
            },
            required: ['success', 'data', 'message']
        }
    },
    {
        name: 'applyNumberFormat',
        annotations: {
            readOnlyHint: false
        },
        description: 'Format numbers in a specific way (e.g., display currency with $ symbol and 2 decimal places). Requires allowNumberFormatting property to be set to true and NumberFormatting module to be injected.',
        inputSchema: {
            type: 'object',
            properties: {
                formatSettings: {
                    type: 'array',
                    description: 'Array of format settings with properties: name, format, useGrouping, currency, etc.',
                    items: {
                        type: 'object',
                        properties: {
                            name: { type: 'string', description: 'The field name to apply formatting to' },
                            format: { type: 'string', description: 'The format string (e.g., C2 for currency with 2 decimals, P for percentage)' },
                            useGrouping: { type: 'boolean', description: 'Whether to use grouping separators' },
                            currency: { type: 'string', description: 'Currency code for currency formatting' }
                        },
                        required: ['name']
                    }
                }
            },
            required: ['formatSettings']
        },
        outputSchema: {
            type: 'object',
            properties: {
                success: { type: 'boolean' },
                data: { type: 'object' },
                message: { type: 'string' }
            },
            required: ['success', 'data', 'message']
        }
    }
];
var WebMcpPivotView = /** @class */ (function () {
    function WebMcpPivotView(parent) {
        this.webMcpAbortController = null;
        this.parent = parent;
        this.parent.webMcpAdapterModule = this;
        this.addEventListener();
    }
    WebMcpPivotView.prototype.addEventListener = function () {
        this.parent.on(getWebMcpTools, this.getTools, this);
        this.parent.on(registerWebMcpTools, this.registerTools, this);
        this.parent.on(executeWebMcpTool, this.executeTool, this);
    };
    WebMcpPivotView.prototype.removeEventListener = function () {
        if (!this.parent.isDestroyed) {
            this.parent.off(getWebMcpTools, this.getTools);
            this.parent.off(registerWebMcpTools, this.registerTools);
            this.parent.off(executeWebMcpTool, this.executeTool);
        }
    };
    WebMcpPivotView.prototype.getTools = function (args) {
        var toolNames = args.toolNames;
        if (toolNames && toolNames.length !== 0) {
            args.tools = webMcpTools.filter(function (webMcpTool) { return toolNames.indexOf(webMcpTool.name) !== -1; })
                .map(function (webMcpTool) { return (__assign({}, webMcpTool)); });
        }
        else {
            args.tools = webMcpTools.map(function (webMcpTool) { return (__assign({}, webMcpTool)); });
        }
        return args.tools;
    };
    WebMcpPivotView.prototype.registerTools = function (args) {
        var _this = this;
        var modelContext = document.modelContext;
        if (!modelContext || typeof modelContext.registerTool !== 'function') {
            console.warn('WebMCP: document.modelContext not available. Tools will not be registered. ' +
                'This is expected in standard browser environments without WebMCP framework.');
            return;
        }
        this.webMcpAbortController = new AbortController();
        var toolPrefix = (isNullOrUndefined(args.prefix) ? this.parent.element.id : args.prefix);
        var tools = args.tools && args.tools.length && typeof args.tools[0] === 'object' ? args.tools :
            this.getTools({ toolNames: args.tools });
        tools.forEach(function (tool) {
            tool.name = toolPrefix + "_" + tool.name;
            tool.execute = function (args) { return __awaiter(_this, void 0, void 0, function () {
                var eventArgs;
                return __generator(this, function (_a) {
                    eventArgs = { toolName: tool.name,
                        toolArgs: args || {} };
                    this.parent.notify(executeWebMcpTool, eventArgs);
                    return [2 /*return*/, eventArgs.response || Promise.reject('WebMcpTools module is not loaded.')];
                });
            }); };
            var registerOptions = {
                signal: _this.webMcpAbortController.signal
            };
            if (Array.isArray(args.exposedTo) && args.exposedTo.length > 0) {
                registerOptions.exposedTo = args.exposedTo;
            }
            modelContext.registerTool(tool, registerOptions);
        });
    };
    WebMcpPivotView.prototype.executeTool = function (eventArgs) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    eventArgs.response = this.executeHandler(eventArgs.toolName, eventArgs.toolArgs || {});
                }
                catch (error) {
                    eventArgs.response = Promise.reject(error);
                }
                return [2 /*return*/];
            });
        });
    };
    WebMcpPivotView.prototype.executeHandler = function (command, args) {
        return __awaiter(this, void 0, void 0, function () {
            var baseCommand, eventArgs, _a, summary, approved;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        baseCommand = command.includes('_') ? command.substring(command.indexOf('_') + 1) : command;
                        eventArgs = { toolName: command, toolArgs: args };
                        this.parent.trigger('beforeWebMcpToolExecute', eventArgs);
                        if (eventArgs.cancel) {
                            return [2 /*return*/, this.message({
                                    action: command,
                                    cancelled: true,
                                    message: eventArgs.cancellationResponse ||
                                        "[USER_CANCELLED] Tool \"" + command + "\" was cancelled. This is final. Do NOT retry."
                                })];
                        }
                        _a = baseCommand;
                        switch (_a) {
                            case 'addFieldToAxis': return [3 /*break*/, 1];
                            case 'removeFieldFromAxis': return [3 /*break*/, 2];
                            case 'moveFieldBetweenAxes': return [3 /*break*/, 3];
                            case 'manageCalculatedField': return [3 /*break*/, 4];
                            case 'clearSorting': return [3 /*break*/, 5];
                            case 'clearConditionalFormatting': return [3 /*break*/, 6];
                            case 'clearNumberFormatting': return [3 /*break*/, 7];
                            case 'setDataSource': return [3 /*break*/, 8];
                            case 'applyFiltering': return [3 /*break*/, 9];
                            case 'applySorting': return [3 /*break*/, 10];
                            case 'applyValueSorting': return [3 /*break*/, 11];
                            case 'clearAllFilters': return [3 /*break*/, 12];
                            case 'applyConditionalFormatting': return [3 /*break*/, 13];
                            case 'exportToExcel': return [3 /*break*/, 14];
                            case 'exportToPDF': return [3 /*break*/, 15];
                            case 'exportToCSV': return [3 /*break*/, 16];
                            case 'drillDownField': return [3 /*break*/, 17];
                            case 'drillUpField': return [3 /*break*/, 18];
                            case 'expandAllHeaders': return [3 /*break*/, 19];
                            case 'collapseAllHeaders': return [3 /*break*/, 20];
                            case 'setChartType': return [3 /*break*/, 21];
                            case 'toggleViewMode': return [3 /*break*/, 22];
                            case 'applyNumberFormat': return [3 /*break*/, 23];
                        }
                        return [3 /*break*/, 24];
                    case 1: return [2 /*return*/, this.handleAddFieldToAxis(args)];
                    case 2: return [2 /*return*/, this.handleRemoveFieldFromAxis(args)];
                    case 3: return [2 /*return*/, this.handleMoveFieldBetweenAxes(args)];
                    case 4: return [2 /*return*/, this.handleManageCalculatedField(args)];
                    case 5: return [2 /*return*/, this.handleClearSorting(args)];
                    case 6: return [2 /*return*/, this.handleClearConditionalFormatting(args)];
                    case 7: return [2 /*return*/, this.handleClearNumberFormatting(args)];
                    case 8: return [2 /*return*/, this.handleSetDataSource(args)];
                    case 9: return [2 /*return*/, this.handleApplyFiltering(args)];
                    case 10: return [2 /*return*/, this.handleApplySorting(args)];
                    case 11: return [2 /*return*/, this.handleApplyValueSorting(args)];
                    case 12: return [2 /*return*/, this.handleClearAllFilters(args)];
                    case 13: return [2 /*return*/, this.handleApplyConditionalFormatting(args)];
                    case 14: return [2 /*return*/, this.handleExportToExcel(args)];
                    case 15: return [2 /*return*/, this.handleExportToPDF(args)];
                    case 16: return [2 /*return*/, this.handleExportToCSV(args)];
                    case 17: return [2 /*return*/, this.handleDrillDownField(args)];
                    case 18: return [2 /*return*/, this.handleDrillUpField(args)];
                    case 19: return [2 /*return*/, this.handleExpandAllHeaders(args)];
                    case 20: return [2 /*return*/, this.handleCollapseAllHeaders(args)];
                    case 21: return [2 /*return*/, this.handleSetChartType(args)];
                    case 22: return [2 /*return*/, this.handleToggleViewMode(args)];
                    case 23: return [2 /*return*/, this.handleApplyNumberFormat(args)];
                    case 24:
                        if (!eventArgs.showConfirmationDialog) return [3 /*break*/, 26];
                        summary = this.buildConfirmationMessage(baseCommand, args);
                        return [4 /*yield*/, this.requestConfirmation(baseCommand, args, summary)];
                    case 25:
                        approved = _b.sent();
                        if (!approved) {
                            return [2 /*return*/, this.message({
                                    action: baseCommand,
                                    cancelled: true,
                                    message: eventArgs.cancellationResponse ||
                                        "[USER_CANCELLED] User denied: \"" + summary + "\". This is final. Do NOT retry."
                                })];
                        }
                        _b.label = 26;
                    case 26: return [2 /*return*/, this.error("Tool \"" + baseCommand + "\" not yet implemented.")];
                }
            });
        });
    };
    WebMcpPivotView.prototype.destroy = function () {
        this.removeEventListener();
        if (this.webMcpAbortController) {
            this.webMcpAbortController.abort();
            this.webMcpAbortController = null;
        }
        this.parent = null;
    };
    WebMcpPivotView.prototype.getModuleName = function () {
        return 'WebMcpPivotView';
    };
    WebMcpPivotView.prototype.message = function (data) {
        return { content: [{ type: 'text', text: JSON.stringify(data) }] };
    };
    WebMcpPivotView.prototype.error = function (text) {
        return { content: [{ type: 'text', text: text }], isError: true };
    };
    WebMcpPivotView.prototype.getOrCreateAxisArray = function (dataSourceSettings, axisProperty) {
        if (axisProperty === 'rows') {
            if (dataSourceSettings.rows) {
                return dataSourceSettings.rows;
            }
            dataSourceSettings.rows = [];
            return dataSourceSettings.rows;
        }
        if (axisProperty === 'columns') {
            if (dataSourceSettings.columns) {
                return dataSourceSettings.columns;
            }
            dataSourceSettings.columns = [];
            return dataSourceSettings.columns;
        }
        if (axisProperty === 'values') {
            if (dataSourceSettings.values) {
                return dataSourceSettings.values;
            }
            dataSourceSettings.values = [];
            return dataSourceSettings.values;
        }
        if (axisProperty === 'filters') {
            if (dataSourceSettings.filters) {
                return dataSourceSettings.filters;
            }
            dataSourceSettings.filters = [];
            return dataSourceSettings.filters;
        }
        return [];
    };
    WebMcpPivotView.prototype.findFieldIndex = function (axisArray, fieldName) {
        for (var i = 0; i < axisArray.length; i++) {
            if (axisArray[i].name === fieldName) {
                return i;
            }
        }
        return -1;
    };
    WebMcpPivotView.prototype.upsertModelByName = function (models, item) {
        var existingIndex = this.findModelIndexByName(models, item.name);
        if (existingIndex !== -1) {
            models[existingIndex] = __assign({}, models[existingIndex], item);
        }
        else {
            models.push(item);
        }
    };
    WebMcpPivotView.prototype.findModelIndexByName = function (models, name) {
        for (var i = 0; i < models.length; i++) {
            if (models[i].name === name) {
                return i;
            }
        }
        return -1;
    };
    WebMcpPivotView.prototype.buildConfirmationMessage = function (command, args) {
        switch (command) {
            case 'addFieldToAxis':
                return "Add field \"" + args.fieldName + "\" to " + args.axis + " axis";
            case 'removeFieldFromAxis':
                return "Remove field \"" + args.fieldName + "\" from " + args.axis + " axis";
            case 'moveFieldBetweenAxes':
                return "Move field \"" + args.fieldName + "\" from " + args.fromAxis + " to " + args.toAxis + " axis";
            case 'setDataSource':
                if (args.dataSource) {
                    if (Array.isArray(args.dataSource) &&
                        args.dataSource.length > 0 &&
                        Array.isArray(args.dataSource[0])) {
                        return "Load CSV data with " + args.dataSource.length + " rows";
                    }
                    else {
                        return "Load JSON data with " + (Array.isArray(args.dataSource)
                            ? args.dataSource.length
                            : 'unknown') + " records";
                    }
                }
                else if (args.url) {
                    return "Load data from URL: " + args.url;
                }
                return 'Load new data source';
            case 'applyFiltering':
                return 'Apply filtering to data';
            case 'applySorting':
                return 'Apply sorting to fields';
            case 'applyValueSorting':
                if (args.valueSortSettings) {
                    return "Apply value sorting with headerText: " + args.valueSortSettings.headerText;
                }
                return 'Apply value sorting';
            case 'clearAllFilters':
                return 'Clear all applied filters';
            case 'applyConditionalFormatting':
                return 'Apply conditional formatting';
            case 'manageCalculatedField':
                return args.action + " calculated field \"" + args.fieldName + "\"";
            case 'clearSorting':
                return 'Clear all applied sorting';
            case 'clearConditionalFormatting':
                return 'Clear all conditional formatting';
            case 'clearNumberFormatting':
                return 'Clear all number formatting';
            case 'exportToExcel': {
                var excelFileName = ((args.exportProperties && args.exportProperties.fileName) ||
                    args.fileName ||
                    'pivot-export.xlsx');
                return "Export to Excel file (" + excelFileName + ")";
            }
            case 'exportToPDF': {
                var pdfFileName = ((args.exportProperties && args.exportProperties.fileName) ||
                    args.fileName ||
                    'pivot-export.pdf');
                return "Export to PDF file (" + pdfFileName + ")";
            }
            case 'exportToCSV': {
                var csvFileName = ((args.exportProperties && args.exportProperties.fileName) ||
                    args.fileName ||
                    'pivot-export.csv');
                return "Export to CSV file (" + csvFileName + ")";
            }
            case 'drillDownField':
                return "Drill down field \"" + args.fieldName + "\"";
            case 'drillUpField':
                return "Drill up field \"" + args.fieldName + "\"";
            case 'expandAllHeaders':
                return 'Expand all headers';
            case 'collapseAllHeaders':
                return 'Collapse all headers';
            case 'setChartType':
                return "Set chart type to " + args.chartType;
            case 'toggleViewMode':
                return "Switch view mode to " + args.viewMode;
            case 'applyNumberFormat':
                return 'Apply number formatting';
            default:
                return "Confirm: " + command;
        }
    };
    WebMcpPivotView.prototype.requestConfirmation = function (command, args, message) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.warn("WebMCP Tool Confirmation: " + message);
                return [2 /*return*/, true];
            });
        });
    };
    WebMcpPivotView.prototype.handleAddFieldToAxis = function (args) {
        try {
            if (!args.fieldName || !args.axis) {
                return this.error('Missing required parameters: fieldName and axis are required');
            }
            var axisMap = {
                'rows': 'rows',
                'columns': 'columns',
                'values': 'values',
                'filters': 'filters'
            };
            var axisProperty = axisMap[args.axis.toLowerCase()];
            if (!axisProperty) {
                return this.error("Invalid axis: " + args.axis + ". Valid axes are: rows, columns, values, filters");
            }
            var dataSourceSettings = this.parent.dataSourceSettings || {};
            var axisArray = this.getOrCreateAxisArray(dataSourceSettings, axisProperty);
            if (this.findFieldIndex(axisArray, args.fieldName) !== -1) {
                return this.message({
                    success: true,
                    data: {},
                    message: "Field \"" + args.fieldName + "\" already exists in " + args.axis + " axis"
                });
            }
            axisArray.push({ name: args.fieldName });
            this.parent.setProperties({ dataSourceSettings: dataSourceSettings }, false);
            return this.message({
                success: true,
                data: {},
                message: "Field \"" + args.fieldName + "\" successfully added to " + args.axis + " axis"
            });
        }
        catch (error) {
            return this.error("Failed to add field to axis: " + error.message);
        }
    };
    WebMcpPivotView.prototype.handleMoveFieldBetweenAxes = function (args) {
        try {
            if (!args.fieldName || !args.fromAxis || !args.toAxis) {
                return this.error('Missing required parameters: fieldName, fromAxis, and toAxis are required');
            }
            var axisMap = {
                'rows': 'rows',
                'columns': 'columns',
                'values': 'values',
                'filters': 'filters'
            };
            var fromAxisProperty = axisMap[args.fromAxis.toLowerCase()];
            var toAxisProperty = axisMap[args.toAxis.toLowerCase()];
            if (!fromAxisProperty) {
                return this.error("Invalid fromAxis: " + args.fromAxis + ". Valid axes are: rows, columns, values, filters");
            }
            if (!toAxisProperty) {
                return this.error("Invalid toAxis: " + args.toAxis + ". Valid axes are: rows, columns, values, filters");
            }
            var dataSourceSettings = this.parent.dataSourceSettings || {};
            var fromAxisArray = this.getOrCreateAxisArray(dataSourceSettings, fromAxisProperty);
            var toAxisArray = this.getOrCreateAxisArray(dataSourceSettings, toAxisProperty);
            var fieldIndex = this.findFieldIndex(fromAxisArray, args.fieldName);
            if (fieldIndex === -1) {
                return this.error("Field \"" + args.fieldName + "\" not found in " + args.fromAxis + " axis");
            }
            var field = fromAxisArray.splice(fieldIndex, 1)[0];
            if (this.findFieldIndex(toAxisArray, args.fieldName) === -1) {
                toAxisArray.push(field);
                this.parent.setProperties({ dataSourceSettings: dataSourceSettings }, false);
                return this.message({
                    success: true,
                    data: {},
                    message: "Field \"" + args.fieldName + "\" successfully moved from " + args.fromAxis + " to " + args.toAxis + " axis"
                });
            }
            else {
                return this.message({
                    success: true,
                    data: {},
                    message: "Field \"" + args.fieldName + "\" already exists in " + args.toAxis + " axis"
                });
            }
        }
        catch (error) {
            return this.error("Failed to move field between axes: " + error.message);
        }
    };
    WebMcpPivotView.prototype.handleRemoveFieldFromAxis = function (args) {
        try {
            if (!args.fieldName || !args.axis) {
                return this.error('Missing required parameters: fieldName and axis are required');
            }
            var axisMap = {
                'rows': 'rows',
                'columns': 'columns',
                'values': 'values',
                'filters': 'filters'
            };
            var axisProperty = axisMap[args.axis.toLowerCase()];
            if (!axisProperty) {
                return this.error("Invalid axis: " + args.axis + ". Valid axes are: rows, columns, values, filters");
            }
            var dataSourceSettings = this.parent.dataSourceSettings || {};
            var axisArray = this.getOrCreateAxisArray(dataSourceSettings, axisProperty);
            var fieldIndex = this.findFieldIndex(axisArray, args.fieldName);
            if (fieldIndex === -1) {
                return this.error("Field \"" + args.fieldName + "\" not found in " + args.axis + " axis");
            }
            axisArray.splice(fieldIndex, 1);
            this.parent.setProperties({ dataSourceSettings: dataSourceSettings }, false);
            return this.message({
                success: true,
                data: {},
                message: "Field \"" + args.fieldName + "\" successfully removed from " + args.axis + " axis"
            });
        }
        catch (error) {
            return this.error("Failed to remove field from axis: " + error.message);
        }
    };
    WebMcpPivotView.prototype.handleManageCalculatedField = function (args) {
        try {
            if (!this.parent.calculatedFieldModule) {
                return this.error('Calculated field module is not enabled. Set allowCalculatedField to true.');
            }
            var action = args.action;
            var fieldName_1 = args.fieldName;
            var formula = args.formula;
            var dataSourceSettings = this.parent.dataSourceSettings || {};
            if (!fieldName_1) {
                var fieldCount = dataSourceSettings.calculatedFieldSettings ? dataSourceSettings.calculatedFieldSettings.length : 0;
                fieldName_1 = "CalculatedField" + (fieldCount + 1);
            }
            if (!dataSourceSettings.calculatedFieldSettings) {
                dataSourceSettings.calculatedFieldSettings = [];
            }
            var calculatedFieldSettings = dataSourceSettings.calculatedFieldSettings;
            var existingFieldIndex = calculatedFieldSettings.findIndex(function (field) { return field.name === fieldName_1; });
            var response = void 0;
            switch (action) {
                case 'create': {
                    if (!formula) {
                        return this.error('Formula is required for creating a calculated field');
                    }
                    if (existingFieldIndex !== -1) {
                        return this.error("Calculated field \"" + fieldName_1 + "\" already exists");
                    }
                    calculatedFieldSettings.push({
                        name: fieldName_1,
                        formula: formula
                    });
                    response = this.message({
                        success: true,
                        data: {},
                        message: "Successfully created calculated field \"" + fieldName_1 + "\" with formula \"" + formula + "\""
                    });
                    break;
                }
                case 'update': {
                    if (!formula) {
                        return this.error('Formula is required for updating a calculated field');
                    }
                    if (existingFieldIndex === -1) {
                        return this.error("Calculated field \"" + fieldName_1 + "\" does not exist");
                    }
                    calculatedFieldSettings[existingFieldIndex].formula = formula;
                    response = this.message({
                        success: true,
                        data: {},
                        message: "Successfully updated calculated field \"" + fieldName_1 + "\" with formula \"" + formula + "\""
                    });
                    break;
                }
                case 'delete': {
                    if (existingFieldIndex === -1) {
                        return this.error("Calculated field \"" + fieldName_1 + "\" does not exist");
                    }
                    calculatedFieldSettings.splice(existingFieldIndex, 1);
                    response = this.message({
                        success: true,
                        data: {},
                        message: "Successfully deleted calculated field \"" + fieldName_1 + "\""
                    });
                    break;
                }
                default:
                    return this.error('Invalid action. Use "create", "update", or "delete"');
            }
            this.parent.setProperties({ dataSourceSettings: dataSourceSettings }, false);
            return response;
        }
        catch (error) {
            return this.error("Failed to manage calculated field: " + error.message);
        }
    };
    WebMcpPivotView.prototype.handleClearSorting = function (args) {
        try {
            var dataSourceSettings = this.parent.dataSourceSettings || {};
            if (!dataSourceSettings.enableSorting) {
                return this.error('Sorting is not enabled. Please set enableSorting property to true.');
            }
            dataSourceSettings.sortSettings = [];
            this.parent.setProperties({ dataSourceSettings: dataSourceSettings }, false);
            return this.message({
                success: true,
                data: {},
                message: 'All sorting successfully cleared'
            });
        }
        catch (error) {
            return this.error("Failed to clear sorting: " + error.message);
        }
    };
    WebMcpPivotView.prototype.handleClearConditionalFormatting = function (args) {
        try {
            if (!this.parent.allowConditionalFormatting) {
                return this.error('Conditional formatting is not enabled. Please set allowConditionalFormatting property to true.');
            }
            if (!this.parent.conditionalFormattingModule) {
                return this.error('Conditional formatting module is not injected. Please ensure the ConditionalFormatting module is included in the requiredModules.');
            }
            var dataSourceSettings = this.parent.dataSourceSettings || {};
            dataSourceSettings.conditionalFormatSettings = [];
            this.parent.setProperties({ dataSourceSettings: dataSourceSettings }, false);
            return this.message({
                success: true,
                data: {},
                message: 'All conditional formatting successfully cleared'
            });
        }
        catch (error) {
            return this.error("Failed to clear conditional formatting: " + error.message);
        }
    };
    WebMcpPivotView.prototype.handleClearNumberFormatting = function (args) {
        try {
            if (!this.parent.allowNumberFormatting) {
                return this.error('Number formatting is not enabled. Please set allowNumberFormatting property to true.');
            }
            if (!this.parent.numberFormattingModule) {
                return this.error('Number formatting module is not injected. Please ensure the NumberFormatting module is included in the requiredModules.');
            }
            var dataSourceSettings = this.parent.dataSourceSettings || {};
            dataSourceSettings.formatSettings = [];
            this.parent.setProperties({ dataSourceSettings: dataSourceSettings }, false);
            return this.message({
                success: true,
                data: {},
                message: 'All number formatting successfully cleared'
            });
        }
        catch (error) {
            return this.error("Failed to clear number formatting: " + error.message);
        }
    };
    WebMcpPivotView.prototype.handleSetDataSource = function (args) {
        try {
            if (!args.dataSource && !args.url) {
                return this.error('Either dataSource or url is required');
            }
            var dataSourceSettings = this.parent.dataSourceSettings || {};
            if (args.dataSource) {
                if (Array.isArray(args.dataSource) && args.dataSource.length > 0 && Array.isArray(args.dataSource[0])) {
                    dataSourceSettings.dataSource = args.dataSource;
                    dataSourceSettings.type = 'CSV';
                }
                else {
                    dataSourceSettings.dataSource = args.dataSource;
                    dataSourceSettings.type = 'JSON';
                }
            }
            if (args.url) {
                dataSourceSettings.url = args.url;
                if (args.type) {
                    dataSourceSettings.type = args.type;
                }
                else if (args.url.toLowerCase().endsWith('.csv')) {
                    dataSourceSettings.type = 'CSV';
                }
                else {
                    dataSourceSettings.type = 'JSON';
                }
            }
            this.parent.setProperties({ dataSourceSettings: dataSourceSettings }, false);
            return this.message({
                success: true,
                data: {},
                message: 'Data source successfully updated'
            });
        }
        catch (error) {
            return this.error("Failed to set data source: " + error.message);
        }
    };
    WebMcpPivotView.prototype.handleApplyFiltering = function (args) {
        var _this = this;
        try {
            if (!args.filters || !Array.isArray(args.filters)) {
                return this.error('Filters array is required');
            }
            var dataSourceSettings_1 = this.parent.dataSourceSettings || {};
            if (!dataSourceSettings_1.filterSettings) {
                dataSourceSettings_1.filterSettings = [];
            }
            args.filters.forEach(function (newFilter) {
                var fieldName = newFilter.name;
                if (!fieldName) {
                    return;
                }
                _this.upsertModelByName(dataSourceSettings_1.filterSettings, newFilter);
            });
            this.parent.setProperties({ dataSourceSettings: dataSourceSettings_1 }, false);
            return this.message({
                success: true,
                data: {},
                message: 'Filters successfully applied'
            });
        }
        catch (error) {
            return this.error("Failed to apply filtering: " + error.message);
        }
    };
    WebMcpPivotView.prototype.handleApplySorting = function (args) {
        var _this = this;
        try {
            if (!args.sortSettings || !Array.isArray(args.sortSettings)) {
                return this.error('SortSettings array is required');
            }
            if (!this.parent.dataSourceSettings.enableSorting) {
                return this.error('Sorting is not enabled. Please set enableSorting property to true.');
            }
            var dataSourceSettings_2 = this.parent.dataSourceSettings || {};
            if (!dataSourceSettings_2.sortSettings) {
                dataSourceSettings_2.sortSettings = [];
            }
            args.sortSettings.forEach(function (newSort) {
                var fieldName = newSort.name;
                if (!fieldName) {
                    return;
                }
                _this.upsertModelByName(dataSourceSettings_2.sortSettings, newSort);
            });
            this.parent.setProperties({ dataSourceSettings: dataSourceSettings_2 }, false);
            return this.message({
                success: true,
                data: {},
                message: 'Sorting successfully applied'
            });
        }
        catch (error) {
            return this.error("Failed to apply sorting: " + error.message);
        }
    };
    WebMcpPivotView.prototype.handleApplyValueSorting = function (args) {
        try {
            if (!args.valueSortSettings) {
                return this.error('valueSortSettings is required');
            }
            var _a = args.valueSortSettings, headerText = _a.headerText, sortOrder = _a.sortOrder;
            if (!headerText || !sortOrder) {
                return this.error('headerText and sortOrder are required in valueSortSettings');
            }
            if (!this.parent.enableValueSorting) {
                return this.error('Value sorting is not enabled. Please set enableValueSorting property to true.');
            }
            var dataSourceSettings = this.parent.dataSourceSettings || {};
            if (!dataSourceSettings.valueSortSettings) {
                dataSourceSettings.valueSortSettings = {};
            }
            dataSourceSettings.valueSortSettings = __assign({}, dataSourceSettings.valueSortSettings, args.valueSortSettings);
            this.parent.setProperties({ dataSourceSettings: dataSourceSettings }, false);
            return this.message({
                success: true,
                data: {},
                message: 'Value sorting successfully applied'
            });
        }
        catch (error) {
            return this.error("Failed to apply value sorting: " + error.message);
        }
    };
    WebMcpPivotView.prototype.handleClearAllFilters = function (args) {
        try {
            var dataSourceSettings = this.parent.dataSourceSettings || {};
            dataSourceSettings.filterSettings = [];
            this.parent.setProperties({ dataSourceSettings: dataSourceSettings }, false);
            return this.message({
                success: true,
                data: {},
                message: 'All filters successfully cleared'
            });
        }
        catch (error) {
            return this.error("Failed to clear all filters: " + error.message);
        }
    };
    WebMcpPivotView.prototype.handleApplyConditionalFormatting = function (args) {
        try {
            if (!args.formatRules || !Array.isArray(args.formatRules)) {
                return this.error('FormatRules array is required');
            }
            var dataSourceSettings_3 = this.parent.dataSourceSettings || {};
            if (!dataSourceSettings_3.conditionalFormatSettings) {
                dataSourceSettings_3.conditionalFormatSettings = [];
            }
            args.formatRules.forEach(function (newRule) {
                dataSourceSettings_3.conditionalFormatSettings.push(newRule);
            });
            this.parent.setProperties({ dataSourceSettings: dataSourceSettings_3 }, false);
            return this.message({
                success: true,
                data: {},
                message: 'Conditional formatting successfully applied'
            });
        }
        catch (error) {
            return this.error("Failed to apply conditional formatting: " + error.message);
        }
    };
    WebMcpPivotView.prototype.handleExportToExcel = function (args) {
        try {
            if (!this.parent.allowExcelExport) {
                return this.error('Excel export is not enabled. Please set allowExcelExport property to true.');
            }
            if (!this.parent.excelExportModule) {
                return this.error('Excel export module is not injected. Please ensure the ExcelExport module is included in the requiredModules.');
            }
            var exportProperties = args.exportProperties || {};
            if (args.fileName && !exportProperties.fileName) {
                exportProperties.fileName = args.fileName;
            }
            this.parent.excelExport(exportProperties);
            return this.message({
                success: true,
                data: { fileName: exportProperties.fileName || 'pivot-export.xlsx' },
                message: 'Excel export initiated'
            });
        }
        catch (error) {
            return this.error("Failed to export to Excel: " + error.message);
        }
    };
    WebMcpPivotView.prototype.handleExportToPDF = function (args) {
        try {
            if (!this.parent.allowPdfExport) {
                return this.error('PDF export is not enabled. Please set allowPdfExport property to true.');
            }
            if (!this.parent.pdfExportModule) {
                return this.error('PDF export module is not injected. Please ensure the PDFExport module is included in the requiredModules.');
            }
            var exportProperties = args.exportProperties || {};
            if (args.fileName && !exportProperties.fileName) {
                exportProperties.fileName = args.fileName;
            }
            this.parent.pdfExport(exportProperties);
            return this.message({
                success: true,
                data: { fileName: exportProperties.fileName || 'pivot-export.pdf' },
                message: 'PDF export initiated'
            });
        }
        catch (error) {
            return this.error("Failed to export to PDF: " + error.message);
        }
    };
    WebMcpPivotView.prototype.handleExportToCSV = function (args) {
        try {
            if (!this.parent.allowExcelExport) {
                return this.error('CSV export is not enabled. Please set allowExcelExport property to true.');
            }
            if (!this.parent.excelExportModule) {
                return this.error('Excel export module is not injected. Please ensure the ExcelExport module is included in the requiredModules.');
            }
            var exportProperties = args.exportProperties || {};
            if (args.fileName && !exportProperties.fileName) {
                exportProperties.fileName = args.fileName;
            }
            this.parent.csvExport(exportProperties);
            return this.message({
                success: true,
                data: { fileName: exportProperties.fileName || 'pivot-export.csv' },
                message: 'CSV export initiated'
            });
        }
        catch (error) {
            return this.error("Failed to export to CSV: " + error.message);
        }
    };
    WebMcpPivotView.prototype.handleDrillDownField = function (args) {
        try {
            if (!args.fieldName || !args.axis) {
                return this.error('fieldName and axis are required');
            }
            var axisMap = {
                'rows': 'rows',
                'columns': 'columns'
            };
            var axisProperty = axisMap[args.axis.toLowerCase()];
            if (!axisProperty) {
                return this.error("Invalid axis: " + args.axis + ". Valid axes are: rows, columns");
            }
            var dataSourceSettings = this.parent.dataSourceSettings || {};
            var axisArray = [];
            if (axisProperty === 'rows') {
                if (!dataSourceSettings.rows) {
                    return this.error("Axis " + args.axis + " is not configured");
                }
                axisArray = dataSourceSettings.rows;
            }
            else if (axisProperty === 'columns') {
                if (!dataSourceSettings.columns) {
                    return this.error("Axis " + args.axis + " is not configured");
                }
                axisArray = dataSourceSettings.columns;
            }
            var fieldIndex = this.findFieldIndex(axisArray, args.fieldName);
            if (fieldIndex === -1) {
                return this.error("Field \"" + args.fieldName + "\" not found in " + args.axis + " axis");
            }
            var drillMembers = args.drillMembers;
            var delimiter = args.delimiter;
            if (!drillMembers || drillMembers.length === 0) {
                dataSourceSettings.expandAll = false;
                dataSourceSettings.drilledMembers = [];
                axisArray[fieldIndex].expandAll = true;
            }
            else {
                dataSourceSettings.expandAll = false;
                dataSourceSettings.drilledMembers = [
                    {
                        name: args.fieldName,
                        items: drillMembers,
                        delimiter: delimiter || '**'
                    }
                ];
                axisArray[fieldIndex].expandAll = false;
            }
            this.parent.setProperties({ dataSourceSettings: dataSourceSettings }, false);
            return this.message({
                success: true,
                data: {},
                message: "Field \"" + args.fieldName + "\" successfully drilled down"
            });
        }
        catch (error) {
            return this.error("Failed to drill down field: " + error.message);
        }
    };
    WebMcpPivotView.prototype.handleDrillUpField = function (args) {
        try {
            if (!args.fieldName || !args.axis) {
                return this.error('fieldName and axis are required');
            }
            var axisMap = {
                'rows': 'rows',
                'columns': 'columns'
            };
            var axisProperty = axisMap[args.axis.toLowerCase()];
            if (!axisProperty) {
                return this.error("Invalid axis: " + args.axis + ". Valid axes are: rows, columns");
            }
            var dataSourceSettings = this.parent.dataSourceSettings || {};
            var axisArray = [];
            if (axisProperty === 'rows') {
                if (!dataSourceSettings.rows) {
                    return this.error("Axis " + args.axis + " is not configured");
                }
                axisArray = dataSourceSettings.rows;
            }
            else if (axisProperty === 'columns') {
                if (!dataSourceSettings.columns) {
                    return this.error("Axis " + args.axis + " is not configured");
                }
                axisArray = dataSourceSettings.columns;
            }
            var fieldIndex = this.findFieldIndex(axisArray, args.fieldName);
            if (fieldIndex === -1) {
                return this.error("Field \"" + args.fieldName + "\" not found in " + args.axis + " axis");
            }
            var drillMembers = args.drillMembers;
            var delimiter = args.delimiter;
            if (!drillMembers || drillMembers.length === 0) {
                dataSourceSettings.expandAll = false;
                dataSourceSettings.drilledMembers = [];
                axisArray[fieldIndex].expandAll = false;
            }
            else {
                dataSourceSettings.expandAll = true;
                dataSourceSettings.drilledMembers = [
                    {
                        name: args.fieldName,
                        items: drillMembers,
                        delimiter: delimiter || '**'
                    }
                ];
                axisArray[fieldIndex].expandAll = true;
            }
            this.parent.setProperties({ dataSourceSettings: dataSourceSettings }, false);
            return this.message({
                success: true,
                data: {},
                message: "Field \"" + args.fieldName + "\" successfully drilled up"
            });
        }
        catch (error) {
            return this.error("Failed to drill up field: " + error.message);
        }
    };
    WebMcpPivotView.prototype.handleExpandAllHeaders = function (args) {
        try {
            var dataSourceSettings = this.parent.dataSourceSettings || {};
            dataSourceSettings.expandAll = true;
            dataSourceSettings.drilledMembers = [];
            this.parent.setProperties({ dataSourceSettings: dataSourceSettings }, false);
            return this.message({
                success: true,
                data: {},
                message: 'All headers successfully expanded'
            });
        }
        catch (error) {
            return this.error("Failed to expand all headers: " + error.message);
        }
    };
    WebMcpPivotView.prototype.handleCollapseAllHeaders = function (args) {
        try {
            var dataSourceSettings = this.parent.dataSourceSettings || {};
            dataSourceSettings.expandAll = false;
            dataSourceSettings.drilledMembers = [];
            this.parent.setProperties({ dataSourceSettings: dataSourceSettings }, false);
            return this.message({
                success: true,
                data: {},
                message: 'All headers successfully collapsed'
            });
        }
        catch (error) {
            return this.error("Failed to collapse all headers: " + error.message);
        }
    };
    WebMcpPivotView.prototype.handleSetChartType = function (args) {
        try {
            if (!args.chartType) {
                return this.error('chartType is required');
            }
            var chartSettings = this.parent.chartSettings || {};
            if (!chartSettings.chartSeries) {
                chartSettings.chartSeries = {};
            }
            chartSettings.chartSeries.type = args.chartType;
            this.parent.setProperties({ chartSettings: chartSettings }, false);
            return this.message({
                success: true,
                data: {},
                message: "Chart type successfully set to " + args.chartType
            });
        }
        catch (error) {
            return this.error("Failed to set chart type: " + error.message);
        }
    };
    WebMcpPivotView.prototype.handleToggleViewMode = function (args) {
        try {
            if (!args.viewMode) {
                return this.error('viewMode is required');
            }
            var validViewModes = ['Table', 'Chart', 'Both'];
            if (validViewModes.indexOf(args.viewMode) === -1) {
                return this.error("Invalid viewMode: " + args.viewMode + ". Valid values are: Table, Chart");
            }
            var displayOption = this.parent.displayOption || {};
            displayOption.view = args.viewMode;
            this.parent.setProperties({ displayOption: displayOption }, false);
            return this.message({
                success: true,
                data: {},
                message: "View mode successfully switched to " + args.viewMode
            });
        }
        catch (error) {
            return this.error("Failed to toggle view mode: " + error.message);
        }
    };
    WebMcpPivotView.prototype.handleApplyNumberFormat = function (args) {
        var _this = this;
        try {
            if (!args.formatSettings || !Array.isArray(args.formatSettings)) {
                return this.error('formatSettings array is required');
            }
            var dataSourceSettings_4 = this.parent.dataSourceSettings || {};
            if (!dataSourceSettings_4.formatSettings) {
                dataSourceSettings_4.formatSettings = [];
            }
            args.formatSettings.forEach(function (newFormat) {
                var fieldName = newFormat.name;
                if (!fieldName) {
                    return;
                }
                _this.upsertModelByName(dataSourceSettings_4.formatSettings, newFormat);
            });
            this.parent.setProperties({ dataSourceSettings: dataSourceSettings_4 }, false);
            return this.message({
                success: true,
                data: {},
                message: 'Number formatting successfully applied'
            });
        }
        catch (error) {
            return this.error("Failed to apply number formatting: " + error.message);
        }
    };
    return WebMcpPivotView;
}());
export { WebMcpPivotView };
